import Vue from 'vue'
import VueRouter from 'vue-router'

// const home = () => import('../views/home.vue')
// const login = () => import('../views/login.vue')
import home from '../views/home.vue'
import login from '../views/login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'home',
    component: home,
  },
 {
    path: '/login',
    component:login
  },

]
const router = new VueRouter({
  routes,
  
//   scrollBehavior (to, from, savedPosition) {
//     if (savedPosition) {
//         
//       return savedPosition
//     } else {
//       return { x: 4, y: 123 }
//     }
//   }
})

export default router
